import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import navbar from "./modules/navbar";
import home from "./modules/home";
import informationUpdates from "./modules/information-updates";
import opportunityForm from "./modules/opportunity-form";
import translationalTeam from "./modules/translational-team";
import contactForm from "./modules/contact-form";
import studentOpportunities from "./modules/student-opportunities";
import terms from "./modules/terms";
import spinner from "./modules/spinner";
import content from "./modules/content";
import sites from "./modules/sites";
import additionalMaterials from "./modules/additionalMaterials";
import pip from "./modules/pip";
import placements from "./modules/placements";
import goals from "./modules/goals";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    navbar,
    home,
    informationUpdates,
    opportunityForm,
    translationalTeam,
    contactForm,
    studentOpportunities,
    terms,
    spinner,
    content,
    sites,
    additionalMaterials,
    pip,
    placements,
    goals
  }
});
